import React from 'react';
import { BsFillPatchCheckFill } from 'react-icons/bs';
import './experience.css';

const Experience = () => {
  return (
    <section id="experience">
      <h5>The Skills I Have</h5>
      <h2>My Experience</h2>
      <div>
      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Fronted Development</h3>
          <div className="experience__content">
          <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>HTML<n /><p style={{fontSize:"13px"}}>Experienced</p></h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>CSS<n /><p style={{fontSize:"13px"}}>Experienced</p></h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>JavaScript<n /><p style={{fontSize:"13px"}}>Experienced</p></h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>React JS<n /><p style={{fontSize:"13px"}}>Experienced</p></h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>Node Js<n /><p style={{fontSize:"13px"}}>Intermediate</p></h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>Redux<n /><p style={{fontSize:"13px"}}>Experienced</p></h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>Tailwind<n /><p style={{fontSize:"13px"}}>Experienced</p></h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>Typescript<n /><p style={{fontSize:"13px"}}>Intermediate</p></h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>Cypress<n /><p style={{fontSize:"13px"}}>Biginner</p></h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>Meterial UI<n /><p style={{fontSize:"13px"}}>Intermediate</p></h4>
            </article>
          </div>
        </div>
      </div>
      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Backend Development</h3>
          <div className="experience__content">
          <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>Node JS<n /><p style={{fontSize:"13px"}}>Experienced</p></h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>MongoDB<n /><p style={{fontSize:"13px"}}>Experienced</p></h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>Express JS<n /><p style={{fontSize:"13px"}}>Experienced</p></h4>
            </article>
            <article className="experience__details">
              <BsFillPatchCheckFill className="experience__details-icon" />
              <h4>JWT<n /><p style={{fontSize:"13px"}}>Experienced</p></h4>
            </article>
            
          </div>
        </div>
      </div>
      </div>
    </section>
  )
}

export default Experience